import { useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './CorpPage.css';
import React, { useState, useEffect } from 'react';

const CorpPage = () => {
    const navigate = useNavigate();
  
    const [loading, setLoading] = useState(false);
    useEffect(() => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 700);
    }, []);
  
    return (
  <div className="container">
        {loading ? (
          <div className="loader-container">
              <div className="spinner"></div>
          </div>
        ) : (
            <div className="item-page-five">
                <div className="overlay"></div>
                <form className="text-form">
                    <fieldset className="search-form__fieldset">
                        <div className="search-form__checkbox-list">
                            <label className="search-form__label">
                                <input
                                type="radio"
                                name="save"
                                className="search-form__checkbox visually-hidden"
                                />
                                <span className="search-form__label-text">3 запуска</span>
                            </label>
                            <label className="search-form__label">
                                <input
                                type="radio"
                                name="save"
                                className="search-form__checkbox visually-hidden"
                                />
                                <span className="search-form__label-text">5 запусков</span>
                            </label>
                        </div>
                    </fieldset>
                </form>
                <button className="layer-button">
        Купить
      </button>
                <BackButton onClick={() => navigate('/fork')} />
            </div>
        )}
    </div>
    );
  };
  
  export default CorpPage;